import { useLocalization } from 'redux/localization/utils/hooks';

const AppError = () => {
  const { t } = useLocalization();

  return (
    <div>
      <h1 className="c7-h1">{t('general.errorMessages.errorGeneral')}</h1>
      <p>{t('general.errorMessages.errorHard')}</p>
    </div>
  );
};
export default AppError;
